<template>
  <div>
    <v-row class="justify-center ">
      <h2 class="primary--text">
        {{ $t(label) }}
      </h2>
    </v-row>
    <v-row>
      <v-col>
        <div class="d-flex justify-end my-4">
          <v-btn v-if="selected.length > 0" @click="submit" color="#007bff">{{
            $t("move exersices")
          }}</v-btn>
        </div>
        <data-table
          @updatePage="getData($event)"
          :headers="headers"
          :data="items"
          :loader="loader"
          :meta="meta"
        >
          <template #header:select>
            <v-row class="justify-center align-center">
              <v-checkbox
                color="white"
                @change="selectAll"
                v-model="select_all"
                :label="$t('select all')"
              >
              </v-checkbox>
            </v-row>
          </template>
          <template #select="{item}">
            <v-row class="justify-center">
              <v-checkbox :value="item.id" v-model="selected"> </v-checkbox>
            </v-row>
          </template>
          <template #show="{item}">
            <showTest :id="id" :exersicesItem="item" />
          </template>
        </data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import showTest from "./showTest.vue";
export default {
  props: ["items", "headers", "meta", "loader", "state", "label", "id"],
  data() {
    return {
      select_all: false,
      selected: [],
      page: 1,
    };
  },
  components: {
    showTest,
  },
  methods: {
    getData(page) {
      this.page = page;
      this.$emit("updatePage", page);
    },
    submit() {
      this.$emit("submit", this.selected);
    },
    selectAll(e) {
      if (e) {
        this.items.forEach((item) => {
          this.selected.push(item.id);
        });
      } else {
        this.selected = this.selected.filter(
          (id) => !this.items.some((obj) => obj.id === id)
        );
      }
    },
  },
  computed: {
    values() {
      return [this.items, this.selected];
    },
  },
  watch: {
    values: {
      deep: true,
      handler() {
        const allIdsIncluded = this.items.every((obj) =>
          this.selected.includes(obj.id)
        );
        if (allIdsIncluded && this.items.length != 0) {
          this.select_all = true;
        } else {
          this.select_all = false;
        }
      },
    },
    state(val) {
      if (val) this.selected = [];
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-input--selection-controls .v-label {
  color: white; /* Replace with your desired label color */
}
</style>
